var _ = { escape: require('lodash.escape') };
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<ul class="profile-cal__day-listing"> ';

    var day = cal.moment(start),
        today = cal.moment();
    ;
__p += ' ';
 cal.each(days_name, function(name) { ;
__p += ' <li class="profile-cal__day-item ' +
__e( day.isSame(today, 'day') ? 'is-active' : '' ) +
'"> ' +
((__t = ( day.format("ddd D/M") )) == null ? '' : __t) +
' ';
 day = day.add(1, "days"); ;
__p += ' ';
 }) ;
__p += ' </li></ul> ' +
((__t = ( cal._week() )) == null ? '' : __t);

}
return __p
};

/*
original source:

<ul class="profile-cal__day-listing">
    <%
    var day = cal.moment(start),
        today = cal.moment();
    %>
    <% cal.each(days_name, function(name) { %>
        <li class="profile-cal__day-item <%- day.isSame(today, 'day') ? 'is-active' : '' %>">
            <%= day.format("ddd D/M") %>
        <% day = day.add(1, "days"); %>
    <% }) %>
</ul>

<%= cal._week() %>

*/
